import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HelperService {
  /**
   * To check if passed value is undefined, null or empty.
   * @param value value to check
   * @returns true or false
   */
  isUndefinedOrNullOrEmpty(value: any): boolean {
    return (
      value === undefined ||
      value === null ||
      value === "" ||
      value === {} ||
      value === [] ||
      (typeof value === "object" && Object.keys(value).length < 1) ||
      value.length < 1
    );
  }

  getFileExtension(fileName: string): string {
    if (!this.isUndefinedOrNullOrEmpty(fileName)) {
      const re = /(?:\.([^.]+))?$/;
      const ext = re.exec(fileName)[1];
      return ext;
    }
    return '';
  }
}
